import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UIModule } from "./ui/ui.module";

@NgModule({

  imports: [CommonModule, UIModule],
})
export class SharedModule {}
